// module_configs/appliances.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie, 
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,faUsersCog,
  faLayerGroup, faBoxes, faCog,
  faBuildingColumns,
  faMoneyBill1Wave
} from '@fortawesome/free-solid-svg-icons';

// Import Appliances components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';
import AddCustomer from '.././module_mechanics/mechanics_customer';
import CustomerList from '.././module_mechanics/mechanics_customer_list';
import AddSupplier from '.././module_mechanics/mechanics_Supplier';
import SupplierList from '.././module_mechanics/mechanics_SuppliersList';
import AddEmployee from '.././module_mechanics/mechanics_employees';
import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';
import AppliancesProducts from '.././module_appliances/appliances_products';
import AppliancesProductsList from '.././module_appliances/appliances_productslist';
import AppliancesPurchases from '.././module_appliances/appliances_Purchases';
import AppliancesPurchaseList from '.././module_appliances/appliances_PurchaseList';
import AppliancesReturn from '.././module_appliances/appliances_Return';
import AppliancesReturnList from '.././module_appliances/appliances_returnlist';
import AppliancesSell from '.././module_appliances/appliances_Sell';
import AppliancesSalesList from '.././module_appliances/appliances_SellList';
import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';
import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';
import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';
import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';
import MechanicsAccounts from '../module_cosmetics/cosmetics_Accounts';
import MechanicsCashLedger from '../module_cosmetics/cosmetics_CashLedger';

export const appliancesConfig = {
  moduleId: 'appliances',
  moduleName: 'Appliances',
  icon: faGaugeHigh,
  description: 'Appliances Management System',
  
  // Dashboard component
  dashboardComponent: DashboardHome,
  
  // Role configurations
  roles: {
    'admin_appliances': { level: 1, label: 'Admin', color: '#ef4444' },
    'manager_appliances': { level: 2, label: 'Manager', color: '#f59e0b' },
    'user_appliances': { level: 3, label: 'User', color: '#10b981' },
    'viewer_appliances': { level: 4, label: 'Viewer', color: '#6366f1' }
  },
  
  // Default menu groups
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  // Menu configuration
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_appliances', 'manager_appliances'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_appliances', 'manager_appliances']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_appliances', 'manager_appliances']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: AppliancesProducts,
          icon: faCube,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: AppliancesProductsList,
          icon: faListAlt,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: AppliancesPurchases,
          icon: faCartPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: AppliancesPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: AppliancesReturn,
          icon: faRotateLeft,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: AppliancesReturnList,
          icon: faListCheck,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'inventory',
      position: 7,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: AppliancesSell,
          icon: faCartPlus,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: AppliancesSalesList,
          icon: faClipboardList,
          roles: ['admin_appliances', 'manager_appliances', 'user_appliances']
        }
      ]
    },
     {
          id: 'financials',  // or 'accounting'
          label: 'Financials',  // or 'Accounting'
          icon: faMoneyBill1Wave,
          roles: ['admin_appliances'],
          groupId: 'sales',
          position: 12,
          submenus: [
            {
              id: 'newtransaction',
              label: 'New Transaction',
              component: AddTransactionForm,
              icon: faPlus,
              roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'alltransactions',
              label: 'All Transactions',
              component: CosmeticsTransactions,
              icon: faMoneyBillWave,
             roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'accounts',
              label: 'Accounts',
              component: MechanicsAccounts,
              icon: faBuildingColumns, // or faUniversity
           roles: ['admin_appliances', 'manager_appliances']
            },
            {
              id: 'cashledger',
              label: 'Cash & Bank Ledger',
              component: MechanicsCashLedger,
              icon: faMoneyBillWave,
             roles: ['admin_appliances', 'manager_appliances']
            }
          ]
        },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_appliances'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_appliances', 'manager_appliances', 'user_appliances'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  // Quick stats
  quickStats: [
    { id: 'todayTasks', label: "Today's Tasks", icon: 'faCheckCircle', value: 24 },
    { id: 'performance', label: 'Performance', icon: 'faChartLine', value: '85%' },
    { id: 'pendingActions', label: 'Pending Actions', icon: 'faClock', value: 12 },
    { id: 'activeUsers', label: 'Active Users', icon: 'faUsers', value: 38 }
  ],
  
  // Keyboard shortcuts
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + T', description: 'Pay Transaction' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + G', description: 'Employees List' },
    { key: 'Alt + V', description: 'Suppliers List' },
    { key: 'Alt + B', description: 'Barcode Printing' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};